"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsive = void 0;
const react_1 = require("react");
const helpers_1 = require("../../helpers");
// Handle window resize and update slider configuration
const useResponsive = (slidesToShow, slidesToShowMedium, slidesToShowMobile, slidesToShowTablet, scrollByOne) => {
    const [currentSlidesToScroll, setCurrentSlidesToScroll] = (0, react_1.useState)(0);
    const [currentSlidesToShow, setCurrentSlidesToShow] = (0, react_1.useState)(0);
    const [gap, setGap] = (0, react_1.useState)(0);
    const [isMobile, setIsMobile] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            let newGap = 0;
            let newSlidesToShow = 0;
            const newIsMobile = currentWidth < helpers_1.Breakpoints.b960;
            if (currentWidth >= helpers_1.Breakpoints.b1920) {
                newSlidesToShow = slidesToShow;
                newGap = 30;
            }
            else if (currentWidth >= helpers_1.Breakpoints.b1280) {
                newSlidesToShow = slidesToShowMedium;
                newGap = 20;
            }
            else if (currentWidth >= helpers_1.Breakpoints.b960) {
                newSlidesToShow = slidesToShowTablet;
                newGap = 15;
            }
            else if (currentWidth <= 770 && currentWidth > helpers_1.Breakpoints.b560) {
                newSlidesToShow = 1;
                newGap = 10;
            }
            else {
                newSlidesToShow = slidesToShowMobile;
                newGap = 16;
            }
            setCurrentSlidesToScroll(scrollByOne ? 1 : Math.floor(newSlidesToShow));
            setCurrentSlidesToShow(newSlidesToShow);
            setGap(newGap);
            setIsMobile(newIsMobile);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [scrollByOne, slidesToShow, slidesToShowMedium, slidesToShowMobile, slidesToShowTablet]);
    return {
        currentSlidesToScroll,
        currentSlidesToShow,
        gap,
        isMobile
    };
};
exports.useResponsive = useResponsive;
